import { render, staticRenderFns } from "./PFSettlementOnHold.vue?vue&type=template&id=491b3679"
import script from "./PFSettlementOnHold.vue?vue&type=script&lang=js"
export * from "./PFSettlementOnHold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports